import { Component, OnInit, EventEmitter } from '@angular/core';
import { Observable, throwError, Subscription } from 'rxjs';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { LoaderService } from '@teem/services/loader.service';
import * as Api from '@teem/core/constants/api';

import { environment } from '@teem/environments/environment';
import { Subject } from 'rxjs/Subject';
import { queryString, uniqueId } from '@teem/helpers/functions';
import { catchError, debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
declare var $;

@Component({
  selector: 'app-monthly-invoice',
  templateUrl: './monthly-invoice.component.html',
  styleUrls: ['./monthly-invoice.component.scss'],
  providers: [UserCurrencyPipe]
})
export class MonthlyInvoiceComponent implements OnInit {

  clientsCount: number = 0;
  activeTab: string = "all-clients";
  paginator: any = {
    id: 'table-paginator',
    currentPage: 1,
    itemsPerPage: environment.pageSize,
    totalItems: 0
  }
  name: string = 'clients';
  searchSubscription: Subscription;
  search = new Subject<string>();
  searchText: string;
  showMenu: boolean = false;
  selected: Array<any> = [];
  selectedRows: Array<any> = [];
  loading: boolean = false;

  filterParams: object = {};
  itemsPerPageOptions = [10, 20, 50, 100];
  data: Array<object> = [];
  onLoad: EventEmitter<any> = new EventEmitter()
  selectable: boolean = false;
  onSelect: EventEmitter<any> = new EventEmitter()
  userInfo: any;
  totalTableColumns: any = 7;
  searchTerm: string = '';

  constructor(
    private loaderService: LoaderService,
    private httpClient: HttpClient,
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.paginator.id = `${this.name}-table-paginator-${uniqueId()}`

    this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
      if (this.searchText != data) {
        this.searchText = data;

        if (this.searchText.length == 0 || this.searchText.length >= 3) {
          this.getPage(1, false);
        }
      }
    })

    this.getPage(1);

    this.sharedDataService.asObservable().subscribe((data) => {
      if (data) {
        if (data.userInfo) {
          this.userInfo = data.userInfo
        }
      }
    })

  }

  reset() {
		this.selected = [];
		this.selectedRows = [];
		this.showMenu = false;
	}

  public getPage(page: number, loading: boolean = true, additionalParams: any = null) {
    // Unselect selected items
    this.reset();

    if (loading) {
      this.loaderService.startLoading();
      this.loading = true; // to show loading text in table
    }

    let params: any = {
      page: page,
      limit: this.paginator.itemsPerPage,
      q: this.searchTerm
    }

    if (this.searchText && this.searchText.length >= 3) {
      params.q = this.searchText;
    }

    if (additionalParams) {
      Object.assign(this.filterParams, additionalParams);
    }

    Object.assign(params, this.filterParams);

    this.getData(params).subscribe(r => {
      if (r.data)
        this.data = r.data;

      if (r.meta) {
        this.paginator.totalItems = r.meta.total;
        this.paginator.currentPage = r.meta.current_page;
        this.paginator.from = r.meta.from;
        this.paginator.to = r.meta.to;
        this.paginator.itemsPerPage = parseInt(r.meta.per_page, 10);
        this.data = r.data;

        this.onLoad.emit({
          totalItems: r.meta.total
        });
      }

      this.loaderService.stopLoading();
      this.loading = false;
      setTimeout(() => {
        $('#tab-links-select[nice-select]').niceSelect('update');
      }, 100);
    }, (err) => {
      this.loading = false;
      this.loaderService.stopLoading()
    })
  }

  getData(params): Observable<any> {
      console.log('in get-data')
      let url = `${Api.invoice.monthlyInvoice}`;
      if (url.indexOf('?') == -1)
        url += ('?' + queryString(params));
      else
        url += ('&' + queryString(params));
  
      return this.httpClient.get(`${url}`).pipe(
        catchError((err: any) => {
          this.loaderService.stopLoading()
          return throwError(err);
        })
      )
    }

  searchInvoice(term: string) {
		this.searchTerm = term;

		this.getPage(1);
	}

  downloadMonthlyInvoice(month: string) {
    if (!month) {
      return;
    }

    const url = `${Api.invoice.downloadMonthlyInvoice}?month=${month}`;
    window.open(url, '_blank');
  }

  onChangeItemsPerPage(event: Event, api: any) {
		const selectElement = event.target as HTMLSelectElement;
		this.paginator.itemsPerPage = +selectElement.value;
		this.getPage(1);
		this.initNiceSelect();
	}

  initNiceSelect() {
		console.log('this is inside.')
		setTimeout(() => {
			const $select = $('#tab-links-select[nice-select]');
			$select.niceSelect?.('destroy');  // clean up
			$select.niceSelect();             // re-init
		}, 10);
	}

  onLoadClients(data: any) {
		this.clientsCount = data.totalItems ? data.totalItems : 0;
		setTimeout(() => {
			$('#tab-links-select[nice-select]').niceSelect('update');
		}, 10);
	}
}
